import clsx from "clsx";
import { HONOR_RANKS, levelStartXp } from "@/lib/levels";

/* Level-System 2.0: Ehrenränge hängen am LEVEL (1/20/40/60/80/95), nicht an
   billigen XP-Schwellen. "Legende" (Lv 95) ist jetzt ein Mehrjahres-Projekt.
   min/max/threshold bleiben als XP-Werte erhalten (aus der Kurve abgeleitet),
   damit alle bestehenden Consumer (CoinBurn, Achievements, …) weiterlaufen. */
const CLS = {
  1: "shadow-sprössling", 2: "shadow-flammenträger", 3: "shadow-blitzdenker",
  4: "shadow-diamantkopf", 5: "shadow-meister", 6: "shadow-legende",
};

const SHADOWS = HONOR_RANKS.map((r, i) => {
  const next = HONOR_RANKS[i + 1] || null;
  const min = levelStartXp(r.level);
  const nextThreshold = next ? levelStartXp(next.level) : null;
  return {
    id: r.id, name: r.name, emoji: r.emoji, color: r.color,
    cls: CLS[r.id] || "shadow-sprössling",
    min, max: nextThreshold ? nextThreshold - 1 : Infinity,
    threshold: min, nextThreshold,
    level: r.level,
    description: r.description,
  };
});

export function getShadow(xp) {
  const v = Math.max(0, xp || 0);
  let found = SHADOWS[0];
  for (const s of SHADOWS) if (v >= s.min) found = s;
  return found;
}

export { SHADOWS };

export default function ShadowBadge({ xp, size = "sm" }) {
  const shadow = getShadow(xp);
  const isLegend = shadow.name === "Legende";

  return (
    <span
      className={clsx(
        "inline-flex items-center gap-1 font-bold rounded-full border transition-all",
        shadow.cls,
        size === "sm" ? "px-2.5 py-0.5 text-[11px]" : "px-3 py-1 text-xs",
        isLegend && "shadow-legend-aura"
      )}
      style={{
        borderColor: `${shadow.color}35`,
        boxShadow: isLegend ? `0 0 12px ${shadow.color}40` : undefined,
      }}
    >
      {shadow.emoji} {shadow.name}
    </span>
  );
}
